<template>
  <div class="tw-flex tw-gap-2">
    <SfButtonDs
      variant="secondary"
      icon-before="paperclip"
      @click="handleEditClick"
    >
      {{ editLabel }}
    </SfButtonDs>
    <SfButtonDs
      v-if="isPartialError"
      variant="ai"
      @click="handleProposalClick"
      >{{ reviewLabel }}</SfButtonDs
    >
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import { UIState } from '../types'
import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'

import { useOCRUI } from '../store/use-ocr-ui'
import { useOCRDocuments } from '../store/use-ocr-documents'

interface Props {
  shouldCloseOnReview?: boolean
  shouldDeclineProposalOnEdit?: boolean
}

const props = defineProps<Props>()

const emit =
  defineEmits<{
    analyze: []
  }>()

const I18n = useI18n()

const editLabel = I18n.t('ai_ocr_requests.steps.edit')
const reviewLabel = I18n.t('ai_ocr_requests.steps.review_proposal')

const documentStore = useOCRDocuments()
const { allDocumentsErroredOut } = storeToRefs(documentStore)

const uiStore = useOCRUI()
const { uiState } = storeToRefs(uiStore)

const isPartialError = computed(
  () => uiState.value === UIState.PartialError && !allDocumentsErroredOut.value
)

function handleEditClick() {
  if (props.shouldDeclineProposalOnEdit) {
    window.modalCitizen.closeModalPortal()
    window.eventHub.$emit('decline-reconciliation-proposal')
  } else {
    if (uiState.value === UIState.Error) {
      documentStore.resetStore()
    }

    if (uiState.value === UIState.PartialError) {
      documentStore.removeDocumentsWithError()
    }

    uiStore.transitionTo(UIState.Edit)
  }
}

function handleProposalClick() {
  if (props.shouldCloseOnReview) {
    window.modalCitizen.closeModalPortal()
  } else {
    documentStore.removeDocumentsWithError()
    emit('analyze')
  }
}
</script>
